import React from 'react'
import { Consumer } from '../../context';
import BlogCard from '../Cards/BlogCardLight';
import {v4 as uuid} from 'uuid';

function Blogs() {

    return (
        <Consumer>
            {(value) => {

                const {blogs} = value;

                return (
                    <div>
                        <div className="font-monospace text-center">
                            <div className="container-fluid pageHeading py-5" >
                                <div className="fs-1">
                                    Blogs
                                </div>
                                <div>
                                    [ Or captions turned out quiet good so let's give them a special page ;) ]
                                </div>
                            </div>

                            <div
                                className="container-fluid align-items-center  pageBackground"
                            >
                                <div className="container">
                                    <div className="row pb-5 px-5 font-monospace">
                                        {blogs.map((blg) => (
                                            <div key={uuid()} className="col-12 col-md-6 col-lg-4 py-lg-5 py-3">
                                                <BlogCard
                                                    //section={blogs}
                                                    blog={blg} />
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
        </Consumer>
    )
}

export default Blogs;
